import { bindable } from 'aurelia';
import { InfoEntity } from '../../apis/info/info-entity';

export class InfoEditor {
    @bindable public info: InfoEntity = null;
}
